import { createFileRoute, redirect } from "@tanstack/react-router";

// Old URL kept alive: permanent redirect to the new question-style URL.
export const Route = createFileRoute("/tica-ayer")({
  beforeLoad: () => {
    throw redirect({ to: "/que-salio-ayer-en-tiempos-jps", statusCode: 301 });
  },
});
